import { render, staticRenderFns } from "./MemberClassesDetail.vue?vue&type=template&id=5617a3dd&scoped=true&"
import script from "./MemberClassesDetail.vue?vue&type=script&lang=js&"
export * from "./MemberClassesDetail.vue?vue&type=script&lang=js&"
import style0 from "./MemberClassesDetail.vue?vue&type=style&index=0&id=5617a3dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5617a3dd",
  null
  
)

export default component.exports